export const MESES_NO_ANO = 12;

/** Economia do anual frente a 12 mensalidades, em pontos percentuais inteiros
 * (0 quando o anual não sai mais barato ou falta algum dos preços). */
export const yearlyDiscountPercent = (monthly: number, yearly: number): number => {
  const dozeMensalidades = monthly * MESES_NO_ANO;
  if (!monthly || !yearly || yearly >= dozeMensalidades) return 0;
  return Math.round(((dozeMensalidades - yearly) / dozeMensalidades) * 100);
};
